import { defineStore } from 'pinia'
import router from "@/router";
import config from "@/config"
import {setStorage,getStorage,transArrayMenuToTree,removeStorage} from '@/utils/util'
import {apiSystemWebRouter} from "@/api/api";
import { ElMessage } from 'element-plus'
import bus from "@/utils/bus"

export const useMutitabsStore = defineStore('mutitabs', {
    state:() => {
        return {
            userId: getStorage('userId') || '' ,
            logintoken:getStorage('logintoken')|| '',
            userName:getStorage('userName')|| '',
            roleNames:getStorage('roleNames')|| '',
            refresh:getStorage('refresh')|| '',
            //mutitabs
            // tabsPage: sessionStorage.getItem('tabsPage')||[{"title":"管理员管理","name":"adminManage"}],//默认显示的页
            // TabsValue: sessionStorage.getItem('TabsValue')||'adminManage',//默认选中显示的标签页
            tabsPage: getStorage('tabsPage')||[],//默认显示的页
            TabsValue: getStorage('TabsValue')||'',//默认选中显示的标签页
            //控制是否支持多选项卡
            isMultiTabs:config.ISMULTITABS,
            isFullscreen:false,//是否全屏
						category:getStorage("category")||"",
						noticeTimeId:getStorage("noticeTimeId") || "",
            cachedViews: [], // 添加缓存视图数组
        }
    },
    getters:{
        // 登录
        getUserId(state) {
              if(!state.userId){
                  state.userId = getStorage('userId')
              }
              return state.userId
        },
        getLogintoken(state) {
              if(!state.logintoken){
                  state.logintoken = getStorage('logintoken')
              }
              return state.logintoken
        },
        getUserName(state) {
              if(!state.userName){
                    state.userName = getStorage('userName')
              }
            return state.userName
        },
        getRefresh(state) {
              if(!state.refresh){
                    state.refresh = getStorage('refresh')
              }
              return state.refresh
        },
    },
    actions: {
        // 登录
        setUserId(val) {
            this.userId = val;
            setStorage('userId',val)
        },
				setnoticeTimeId(val){
					this.noticeTimeId = val
					setStorage('noticeTimeId',val)
				},
				setCategory(val){
					this.category = val
					setStorage('category',val)
				},
        setLogintoken(val) {
            this.logintoken = val;
            setStorage('logintoken',val)
        },
        setUserName(val) {
            this.userName = val;
            setStorage('userName',val)
        },
        setRefresh(val) {
            this.refresh = val;
            setStorage('refresh',val)
        },
        refreshUserinfo(val){
            this.roleNames = val.role_names
            this.userName = val.name
            setStorage('roleNames',this.roleNames)
            setStorage('userName',this.userName)
        },
        // 退出
        logout(val) {
            this.userId = ''
            this.logintoken = ''
            this.userName = ''
            this.refresh = ''
            this.roleNames = ''
            this.tabsPage=[]
            this.TabsValue = ""
            removeStorage("userId")
            removeStorage("logintoken")
            removeStorage("userName")
            removeStorage("refresh")
            removeStorage("roleNames")
            removeStorage("tabsPage")
            removeStorage("TabsValue")
        },
        //首次登录第一个标签页获取
        firstTabs(datas){
            if(this.tabsPage.length==0){
                this.tabsPage=datas[0]
                setStorage("tabsPage", JSON.stringify(this.tabsPage))
            }
            if(this.TabsValue=="") {
                this.TabsValue = datas[1]
                setStorage("TabsValue", this.TabsValue)
            }

        },
        //mutitabs
        editableTabs(obj){
          // 浅拷贝 state.tabsPage
          const arr = Array.from(this.tabsPage)
          // 判断数组内是否为空
          if (arr.length !== 0) {
            // 使用 Array.some 去判断是否存在对象信息
            var even = function (obj) {
              return arr.some(item => {
                return item.name === obj.attributes.url
              })
            }
            // even方法 如果对象存在返回true,不存在则返回flase
            // 加！触发 true 代码块
            if (!even(obj)/* 如果不存在将对象push进数组内bing */) {
              // 将tabs所需参数push进arr数组
              arr.push({ title: obj.text, name: obj.attributes.url })
              // 赋值给tabsPage参数
              this.tabsPage = arr
              // 存储localStorage -- 解决刷新消失
              setStorage('tabsPage', JSON.stringify(arr))
              setStorage('TabsValue', obj.attributes.url)
              // 赋值给TabsValue参数
              this.TabsValue = obj.attributes.url
              // 跳转
              router.push({ name: obj.attributes.url })
            } else { // 如果存在 只做跳转选中
              // 赋值给TabsValue参数
              this.TabsValue = obj.attributes.url
              setStorage('TabsValue', obj.attributes.url)
              // 跳转
              router.push({ name: obj.attributes.url })
            }
          } else { // 如果为0
            // 将tabs所需参数push进arr数组
            arr.push({
              title: obj.text, name: obj.attributes.url
            })
            // 赋值给tabsPage参数
            this.tabsPage = arr
            // 赋值给TabsValue参数
            this.TabsValue = obj.attributes.url
            // 跳转
            router.push({ name: obj.attributes.url })
          }
        },
         //切换tab菜单(没有标签则重新创建)
        switchtab(curContextTabName,routeQuery = null){
            this.TabsValue = curContextTabName
            setStorage('TabsValue', curContextTabName)
            var arr = this.tabsPage
            if (Object.prototype.toString.call(arr) === '[object String]') {
                // 字符串需要转换
                arr = JSON.parse(arr);
            }
            if(arr.some(item => item.name === curContextTabName)){
                arr.forEach(item=>{
                    if(item.name === curContextTabName){
                        routeQuery =  !!item.query?item.query:{}
                    }
                })
            }else{
                var menuList = JSON.parse(getStorage('menuList'))
                var curContextTabObj = menuList.filter(item=>item.url === curContextTabName)
                if(curContextTabObj.length>0){
                    routeQuery = !!routeQuery?routeQuery:{}
                    // 将tabs所需参数push进arr数组
                    arr.push({ title: curContextTabObj[0].moduleName, name: curContextTabName,query:routeQuery })
                    // 赋值给tabsPage参数
                    this.tabsPage = arr
                    // 存储localStorage -- 解决刷新消失
                    setStorage('tabsPage', JSON.stringify(arr))
                }
            }
            router.push({ name: curContextTabName ,query:routeQuery });
        },
        //切换tab菜单(没有标签则重新创建)-只切换标签，不发送路由
        switchtabNoRoute(curContextTabName,routeQuery = null){
            if(this.TabsValue != curContextTabName){
                this.TabsValue = curContextTabName
                var arr = this.tabsPage
                if (Object.prototype.toString.call(arr) === '[object String]') {
                    // 字符串需要转换
                    arr = JSON.parse(arr);
                }
                if(!arr.some(item => item.name === curContextTabName)){
                    var menuList = getStorage('menuList')
                    if(menuList){
                        menuList = JSON.parse(getStorage('menuList'))
                        if(menuList.length>0){
                            var curContextTabObj = menuList.filter(item=>item.url === curContextTabName)
                            if(curContextTabObj.length>0){
                                let currentRouteQuery = !!routeQuery?routeQuery:{}
                                // 将tabs所需参数push进arr数组
                                arr.push({ title: curContextTabObj[0].moduleName, name: curContextTabName,query: currentRouteQuery })
                                // 赋值给tabsPage参数
                                this.tabsPage = arr
                                setStorage('TabsValue', curContextTabName)
                                // 存储localStorage -- 解决刷新消失
                                setStorage('tabsPage', JSON.stringify(arr))
                            }
                        }
                    }
                }
            }
        },
        //自定义右键菜单
        // 保存右键点击tab的id
        saveCurContextTabId(curContextTabId) {
          this.TabsValue = curContextTabId
        },
        // 关闭所有标签(只保留第一个标签页)
        closeAllTabs() {
            // 清空所有标签
            this.tabsPage = []
            this.TabsValue = ""
            setStorage('tabsPage', JSON.stringify([]))
            setStorage('TabsValue', "")
            
            // 获取菜单数据
            const menuList = JSON.parse(getStorage('menuList') || '[]')
            if (menuList.length > 0) {
                // 找到第一个菜单项
                const firstMenu = menuList[0]
                // 创建第一个标签
                const firstTab = {
                    title: firstMenu.moduleName,
                    name: firstMenu.url,
                    query: {}
                }
                this.tabsPage = [firstTab]
                this.TabsValue = firstMenu.url
                setStorage('tabsPage', JSON.stringify([firstTab]))
                setStorage('TabsValue', firstMenu.url)
                // 跳转到第一个菜单
                router.push({ name: firstMenu.url })
            }
        },
        // 关闭其它标签页
        closeOtherTabs(par) {
          let tabs = this.tabsPage;
          let length = tabs.length;
          let curContextTabId = this.TabsValue;
          let id; // 右键点击时的tab在整个tabs数组中的id
          tabs.forEach((tab, index) => {
            if (tab.name == curContextTabId) {
                id = index
                return false
            }
          })
          if (par == "left") {
            if (id >= 0) {
                this.tabsPage = this.tabsPage.slice(id, length)
                setStorage('tabsPage', JSON.stringify(this.tabsPage))
                this.checkTbasRouter()
            }
          }
          if (par == "right") {
            if (id >= 0) {
                this.tabsPage = this.tabsPage.slice(0, id + 1)
                setStorage('tabsPage', JSON.stringify(this.tabsPage))
                this.checkTbasRouter()
            }
          }
          if (par == "other") {
              this.tabsPage = [tabs[id]]
              this.TabsValue = tabs[id].name
              setStorage('tabsPage', JSON.stringify(this.tabsPage))
              setStorage('TabsValue', this.TabsValue)
              this.checkTbasRouter()
          }
        },
        //解决标签与路由不一致问题（检查标签栏当前选择与当前路由不同则路由跳转至改标签栏）
        checkTbasRouter(){
            if(router.currentRoute.value.name != this.TabsValue){
                router.push({ name: this.TabsValue})
            }
        },
        // 重新获取左侧菜单信息
        getMenu() {
            apiSystemWebRouter().then(res=>{
                if(res.code == 2000) {
                    let menuTree = []
                    if(res.data.data.length > 0) {
                        //转换菜单为结构树
                        menuTree = transArrayMenuToTree(res.data.data)
                        // 操作权限管控
                        let menuList=[]
                        res.data.data.forEach(item=>{
                            //console.log(item,'item---- 菜单权限---')
                            menuList.push({
                                url:item.web_path,
                                moduleName:item.name,
                                menuPermission:item.menuPermission
                            })
                        })
                        setStorage('menuList', JSON.stringify(menuList))
                    }
                    setStorage('allmenu', JSON.stringify(menuTree))
                    bus.emit('routeReload', true)
                } else {
                    ElMessage.warning(res.msg)
                }
            })
        },
        // 添加缓存视图
        addCachedView(view) {
            if (this.cachedViews.includes(view.name)) return
            if (view.meta && view.meta.cache) {
                this.cachedViews.push(view.name)
            }
        },
        
        // 删除缓存视图
        removeCachedView(view) {
            const index = this.cachedViews.indexOf(view.name)
            if (index > -1) {
                this.cachedViews.splice(index, 1)
            }
        },
        
        // 清除所有缓存视图
        clearCachedViews() {
            this.cachedViews = []
        }
    },
})